import { Box } from '@mui/material';
import { Svgs } from '../../../../assets/svg';

interface PlaceholderInstitutionLogoProps {
  size?: 'sm' | 'md' | 'lg';
}

const PlaceholderInstitutionLogo: React.FC<PlaceholderInstitutionLogoProps> = ({ size = 'md' }) => {
  const containerSize = size === 'sm' ? 20 : size === 'lg' ? 35 : 25;
  const logoSize = size === 'sm' ? 15 : size === 'lg' ? 30 : 20;
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: '#fff',
        border: '1px solid #bfbfbf',
        borderRadius: '50%',
        display: 'flex',
        flexShrink: 0,
        height: containerSize,
        justifyContent: 'center',
        width: containerSize,
      }}>
      <Svgs.DisplaySmallCustomInstitution
        className='svg-img'
        style={{
          height: logoSize,
          width: logoSize,
        }}
      />
    </Box>
  );
};

export default PlaceholderInstitutionLogo;
